import { Component, DestroyRef, inject, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { NgClass } from '@angular/common';
import { ModalComponent } from '../../../shared/components/modal/modal';
import { TaxonomyService } from '../../../core/services/taxonomy.service';
import { ToastService } from '../../../core/services/toast.service';
import { apiErrorMessage } from '../../../shared/utils/api-error';

type ClassificationType = 'Situation' | 'Response';

@Component({
  selector: 'app-create-taxonomy-modal',
  imports: [ModalComponent, NgClass],
  templateUrl: './create-taxonomy-modal.html',
})
export class CreateTaxonomyModalComponent {
  closed = output<void>();
  saved = output<void>();

  private taxonomyService = inject(TaxonomyService);
  private toastService = inject(ToastService);
  private destroyRef = inject(DestroyRef);

  protected taxonomyName = signal('');
  protected classificationType = signal<ClassificationType>('Situation');
  protected isMultiItem = signal(true);
  protected showErrors = signal(false);
  protected submitting = signal(false);

  protected onSubmit(): void {
    this.showErrors.set(true);
    if (!this.taxonomyName().trim()) return;

    this.submitting.set(true);
    const name = this.taxonomyName().trim();
    const isMultiItem = this.isMultiItem();
    const request$: Observable<unknown> =
      this.classificationType() === 'Situation'
        ? this.taxonomyService.createSituationTaxonomy({ name, isMultiItem })
        : this.taxonomyService.createResponseTaxonomy({ taxonomyName: name, isMultiItem });

    request$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.toastService.show('Taxonomy created successfully');
        this.saved.emit();
      },
      error: (err) => {
        this.toastService.show(apiErrorMessage(err, 'Failed to create taxonomy'), 'error');
        this.submitting.set(false);
      },
    });
  }
}
